import { render, staticRenderFns } from "./asset-dropdown.vue?vue&type=template&id=28c9e5f0&scoped=true"
import script from "./asset-dropdown.vue?vue&type=script&lang=js"
export * from "./asset-dropdown.vue?vue&type=script&lang=js"
import style0 from "./asset-dropdown.vue?vue&type=style&index=0&id=28c9e5f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c9e5f0",
  null
  
)

export default component.exports